import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { apiFetch } from "@/lib/api";
import {
  getVediCome,
  VEDI_COME_EVENT,
  type VediComeStato,
} from "@/lib/vedi-come";
import type { VediComeContesto } from "@/types/api";

/**
 * Stato corrente dell'impersonazione, reattivo: si aggiorna a ogni set/clear
 * (via evento window) così banner e selettore restano sincronizzati.
 */
export function useVediComeStato(): VediComeStato | null {
  const [stato, setStato] = useState<VediComeStato | null>(() => getVediCome());
  useEffect(() => {
    const onChange = () => setStato(getVediCome());
    window.addEventListener(VEDI_COME_EVENT, onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener(VEDI_COME_EVENT, onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);
  return stato;
}

/**
 * Contesto del selettore «Vedi come». Usa l'identità REALE lato backend
 * (ignora l'header X-Vedi-Come), quindi `puo_impersonare` resta veritiero
 * anche mentre stai impersonando.
 */
export function useVediComeContesto() {
  return useQuery({
    queryKey: ["me", "vedi-come"],
    queryFn: () => apiFetch<VediComeContesto>("/api/v1/me/vedi-come"),
    staleTime: 5 * 60_000,
  });
}
